import React, { useState } from 'react';
import FeelingsNeedsHelper from '../FeelingsNeedsHelper';
import { FeelIcon, NeedIcon } from '../icons/ElchmeIcons';

/**
 * FloatingFeelingsHelper - A persistent floating button that opens the Feelings & Needs Helper
 * Can be added to any page to make the helper always accessible
 */
export default function FloatingFeelingsHelper() {
  const [isOpen, setIsOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <div 
        className="fixed bottom-24 right-6 z-40 flex flex-col items-end gap-2"
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        {/* Expanded tooltip */}
        {isExpanded && (
          <div className="bg-slate-800/95 backdrop-blur-sm border border-rose-500/30 rounded-lg px-4 py-2 text-sm text-white shadow-lg animate-in fade-in slide-in-from-right-2 duration-200">
            <span className="text-rose-300 font-medium">Feelings & Needs Helper</span>
            <p className="text-slate-400 text-xs mt-1">Click to explore emotions & needs</p>
          </div>
        )}
        
        {/* Main Button */}
        <button
          onClick={() => setIsOpen(true)}
          className="group relative w-14 h-14 bg-gradient-to-br from-rose-600 to-pink-600 hover:from-rose-500 hover:to-pink-500 rounded-full shadow-lg shadow-rose-500/30 flex items-center justify-center transition-all hover:scale-110 active:scale-95"
          aria-label="Open Feelings & Needs Helper"
          data-testid="floating-feelings-helper-btn"
        >
          {/* Pulsing ring animation */}
          <div className="absolute inset-0 rounded-full bg-rose-500/30 animate-ping" style={{ animationDuration: '2s' }} />
          
          {/* Icons */}
          <div className="relative flex items-center gap-0.5">
            <FeelIcon size={20} />
            <span className="text-white/60 text-xs">+</span>
            <NeedIcon size={18} />
          </div>
        </button>
      </div>

      {/* Helper Modal */}
      {isOpen && (
        <FeelingsNeedsHelper onClose={() => setIsOpen(false)} />
      )}
    </>
  );
}
